export default __webpack_public_path__ + "static/media/teslaLogoSmall.a7b59bc6.svg";